import { Controllers } from 'lib/enums/routes/_controllers';
import { SecuritiesRoutes } from 'lib/enums/routes/securities';
import { SecurityDoc, SecurityWhole } from 'lib/interfaces/database/security';
import { BaseService } from 'services/_base';

export class SecuritiesService extends BaseService {
  private static instance: SecuritiesService;

  static getInstance(): SecuritiesService {
    if (!SecuritiesService.instance) {
      SecuritiesService.instance = new SecuritiesService();
    }

    return SecuritiesService.instance;
  }

  private constructor() {
    super({
      controller: Controllers.securities,
    });
  }

  search(payload: Partial<SecurityDoc>) {
    return this.POST(
      {
        uri: SecuritiesRoutes.Search,
      },
      payload
    )
      .then((result: SecurityWhole[]) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  create(payload: Partial<SecurityDoc>) {
    return this.POST(
      {
        uri: SecuritiesRoutes.CreateOne,
      },
      payload
    )
      .then((result: SecurityWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  update(id: string, payload: Partial<SecurityDoc>) {
    return this.PUT(
      {
        uri: `${SecuritiesRoutes.UpdateOne}/${id}`,
      },
      payload
    )
      .then((result: SecurityWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }
}
